import { DateUtil, isNullOrUndefined } from '@uzurv/rideWss/app/util';
import { AbstractModel } from './abstract-model';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class PositionUpdate extends AbstractModel {
  @autoserialize
  personId: number;

  @autoserialize
  latitude: number;

  @autoserialize
  longitude: number;

  @autoserializeAs(Date)
  timestamp: Date;

  @autoserialize
  deviceInstallationId: number;

  static OnSerialized(instance: PositionUpdate, json: any): void {
    super.OnSerialized(instance, json);

    // Make sure there isn't too much precision for database
    if (!isNullOrUndefined(instance.latitude)) {
      json.latitude = parseFloat(instance.latitude.toFixed(6));
    }
    if (!isNullOrUndefined(instance.longitude)) {
      json.longitude = parseFloat(instance.longitude.toFixed(6));
    }
  }

  static OnDeserialized(instance: PositionUpdate, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['timestamp'])) {
      instance.timestamp = DateUtil.deserializeInstant(json['timestamp']);
    }
  }
}
